import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import TermsPage from './components/TermsPage';
import PrivacyPage from './components/PrivacyPage';
import HomePage from './components/HomePage';
import PublicDocumentPage from './components/PublicDocumentPage';
import EulaEnPage from './components/EulaEnPage';
import PrivacyPolicyEnPage from './components/PrivacyPolicyEnPage';
import './App.css';
const AdminPage = lazy(() => import('./admin/AdminPage'));

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/admin/*" element={<Suspense fallback={<p>正在加载管理后台…</p>}><AdminPage /></Suspense>} />
          <Route path="/" element={<HomePage />} />
          <Route path="/terms/eula" element={<TermsPage />} />
          <Route path="/terms/privacy-policy" element={<PrivacyPage />} />
          <Route path="/terms/marketing-en" element={<PublicDocumentPage file="marketing.md" />} />
          <Route path="/terms/marketing" element={<PublicDocumentPage file="marketing-zh.md" />} />
          <Route path="/terms/support-en" element={<PublicDocumentPage file="support-en.md" />} />
          <Route path="/terms/support" element={<PublicDocumentPage file="support.md" />} />
          <Route path="/terms/eula-en" element={<EulaEnPage />} />
          <Route path="/terms/privacy-policy-en" element={<PrivacyPolicyEnPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
